import React from 'react';
import { AutoComplete, DatePicker, Radio, RadioGroup, Input, Form, Schema, Button, Modal, CheckPicker, IconButton } from 'rsuite';
import CloseIcon from '@rsuite/icons/Close';
import { Field } from './common/Field'
import { schools } from '../data/schools'

const nationalities = ['Afghan',
'Albanian',
'Algerian',
'American',
'Andorran',
'Angolan',
'Antiguans',
'Argentinean',
'Armenian',
'Australian',
'Austrian',
'Azerbaijani',
'Bahamian',
'Bahraini',
'Bangladeshi',
'Barbadian',
'Barbudans',
'Batswana',
'Belarusian',
'Belgian',
'Belizean',
'Beninese',
'Bhutanese',
'Bolivian',
'Bosnian',
'Brazilian',
'British',
'Bruneian',
'Bulgarian',
'Burkinabe',
'Burmese',
'Burundian',
'Cambodian',
'Cameroonian',
'Canadian',
'Cape Verdean',
'Central African',
'Chadian',
'Chilean',
'Chinese',
'Colombian',
'Comoran',
'Congolese',
'Costa Rican',
'Croatian',
'Cuban',
'Cypriot',
'Czech',
'Danish',
'Djibouti',
'Dominican',
'Dutch',
'East Timorese',
'Ecuadorean',
'Egyptian',
'Emirian',
'Equatorial Guinean',
'Eritrean',
'Estonian',
'Ethiopian',
'Fijian',
'Filipino',
'Finnish',
'French',
'Gabonese',
'Gambian',
'Georgian',
'German',
'Ghanaian',
'Greek',
'Grenadian',
'Guatemalan',
'Guinea-Bissauan',
'Guinean',
'Guyanese',
'Haitian',
'Herzegovinian',
'Honduran',
'Hungarian',
'I-Kiribati',
'Icelander',
'Indian',
'Indonesian',
'Iranian',
'Iraqi',
'Irish',
'Israeli',
'Italian',
'Ivorian',
'Jamaican',
'Japanese',
'Jordanian',
'Kazakhstani',
'Kenyan',
'Kittian and Nevisian',
'Kuwaiti',
'Kyrgyz',
'Laotian',
'Latvian',
'Lebanese',
'Liberian',
'Libyan',
'Liechtensteiner',
'Lithuanian',
'Luxembourger',
'Macedonian',
'Malagasy',
'Malawian',
'Malaysian',
'Maldivian',
'Malian',
'Maltese',
'Marshallese',
'Mauritanian',
'Mauritian',
'Mexican',
'Micronesian',
'Moldovan',
'Monacan',
'Mongolian',
'Moroccan',
'Mosotho',
'Motswana',
'Mozambican',
'Namibian',
'Nauruan',
'Nepalese',
'New Zealander',
'Ni-Vanuatu',
'Nicaraguan',
'Nigerian',
'Nigerien',
'North Korean',
'Northern Irish',
'Norwegian',
'Omani',
'Pakistani',
'Palauan',
'Panamanian',
'Papua New Guinean',
'Paraguayan',
'Peruvian',
'Polish',
'Portuguese',
'Qatari',
'Romanian',
'Russian',
'Rwandan',
'Saint Lucian',
'Salvadoran',
'Samoan',
'San Marinese',
'Sao Tomean',
'Saudi',
'Scottish',
'Senegalese',
'Serbian',
'Seychellois',
'Sierra Leonean',
'Singaporean',
'Slovakian',
'Slovenian',
'Solomon Islander',
'Somali',
'South African',
'South Korean',
'Spanish',
'Sri Lankan',
'Sudanese',
'Surinamer',
'Swazi',
'Swedish',
'Swiss',
'Syrian',
'Taiwanese',
'Tajik',
'Tanzanian',
'Thai',
'Togolese',
'Tongan',
'Trinidadian or Tobagonian',
'Tunisian',
'Turkish',
'Tuvaluan',
'Ugandan',
'Ukrainian',
'Uruguayan',
'Uzbekistani',
'Venezuelan',
'Vietnamese',
'Welsh',
'Yemenite',
'Zambian',
'Zimbabwean']
// School suggestions are generated from the MOE directory + curated lists —
// see z-scripts/refresh-schools.js. Items carry the abbreviations parents
// actually type ("UWC", "OFS", …) so the autocomplete matches them too.
const schoolItems = schools.map(s => ({ label: s.name, value: s.name, aliases: s.aliases }));
const schoolFilter = (inputValue, item) => {
    const q = (inputValue || '').toLowerCase().trim();
    if (!q) return true;
    return item.value.toLowerCase().includes(q) ||
        (item.aliases || []).some(a => a.toLowerCase().includes(q));
};


const model = Schema.Model({
    firstName: Schema.Types.StringType().isRequired('This field is required.'),
    lastName: Schema.Types.StringType().isRequired('This field is required.'),
    gender: Schema.Types.StringType().isRequired('This field is required.'),
    dob: Schema.Types.DateType().isRequired('This field is required.'),
    nationality: Schema.Types.StringType().isRequired('This field is required.'),
    school: Schema.Types.StringType().isRequired('This field is required.')
});


function getDateMinusYears(offsetYears) {
    var d = new Date();
    d.setFullYear(d.getFullYear() - offsetYears);
    return d;
}

const KidInfo = ({ kid, createKid, setKid, setCreateKid, createOrUpdateKid }) => {

    const [formValue, setFormValue] = React.useState({
        firstName: kid ? kid.firstName : "",
        lastName: kid ? kid.lastName : "",
        gender: kid ? kid.gender : null,
        dob: kid ? new Date(kid.dob) : null,
        nationality: kid ? kid.nationality : "",
        school: kid ? kid.school : "",
        foodPreferences: kid ? kid.foodPreferences : [],
        medicalConditions: kid ? kid.medicalConditions : "",
    });

    const formRef = React.useRef();

    const handleClose = () => {
        kid ? setKid(null) : setCreateKid(false)
    }

    const handleSubmit = () => {
        if (!formRef.current.check()) {
            console.error('Form Error');
            return;
        }

        createOrUpdateKid(kid ? kid._id : null, {
            user: localStorage.getItem("user-id"),
            firstName: formValue.firstName,
            lastName: formValue.lastName,
            gender: formValue.gender,
            dob: formValue.dob,
            nationality: formValue.nationality,
            school: formValue.school,
            foodPreferences: formValue.foodPreferences,
            medicalConditions: formValue.medicalConditions
        });
        handleClose();
    };

    return (
        <Modal open={!!kid || createKid} onClose={handleClose} backdrop="static" keyboard className="kid-modal">
            <Modal.Header closeButton={false}>
                <div className="flex items-center justify-between gap-3">
                    <div>
                        <Modal.Title>{kid ? `Edit ${kid.firstName}'s profile` : 'Add a child'}</Modal.Title>
                        <p className="text-sm text-gray-500 m-0 mt-1">
                            We use these details for camp registration and catering.
                        </p>
                    </div>
                    <IconButton
                        icon={<CloseIcon />}
                        appearance="subtle"
                        circle
                        aria-label="Close"
                        onClick={handleClose}
                        style={{ width: 40, height: 40, flexShrink: 0 }}
                    />
                </div>
            </Modal.Header>

            <Modal.Body>
                <Form
                    ref={formRef}
                    onChange={setFormValue}
                    formValue={formValue}
                    model={model}
                    fluid
                    className="kid-modal-form">

                    <Field
                        name="firstName"
                        label={<>First name <span style={{ color: 'red' }}>*</span></>}
                    />

                    <Field
                        name="lastName"
                        label={<>Last name <span style={{ color: 'red' }}>*</span></>}
                    />

                    {/* Gender + DOB share a row so the short date field isn't a lone narrow one */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 sm:gap-x-4">
                        <Field
                            name="gender"
                            label={<>Gender <span style={{ color: 'red' }}>*</span></>}
                            accepter={RadioGroup}
                            inline
                        >
                            <Radio value="M">Male</Radio>
                            <Radio value="F">Female</Radio>
                        </Field>

                        <Field
                            placeholder="DD/MM/YYYY"
                            name="dob"
                            label={<>Date of birth <span style={{ color: 'red' }}>*</span></>}
                            accepter={DatePicker}
                            shouldDisableDate={(d) => d > getDateMinusYears(2)}
                            format="dd/MM/yyyy"
                            oneTap
                            ranges={[]}
                            calendarDefaultDate={getDateMinusYears(9)}
                        />
                    </div>

                    <Field
                        placeholder="Start typing to search…"
                        name="nationality"
                        label={<>Nationality <span style={{ color: 'red' }}>*</span></>}
                        accepter={AutoComplete}
                        data={nationalities}
                    />

                    <Field
                        placeholder="Start typing to search…"
                        name="school"
                        label={<>School <span style={{ color: 'red' }}>*</span></>}
                        accepter={AutoComplete}
                        data={schoolItems}
                        filterBy={schoolFilter}
                    />

                    <Field
                        placeholder="No preferences"
                        name="foodPreferences"
                        label="Food preferences"
                        accepter={CheckPicker}
                        data={[
                            { value: "vegetarian", label: "Vegetarian" },
                            { value: "gluten-free", label: "Gluten-free" },
                            { value: "halal", label: "Halal" },
                            { value: "other", label: "Other" },
                        ]}
                        searchable={false}
                    />

                    <Field
                        placeholder="e.g. asthma, nut allergy — leave blank if none"
                        name="medicalConditions"
                        label="Medical conditions"
                        accepter={Input}
                    />

                </Form>
            </Modal.Body>

            <Modal.Footer>
                <div className="flex justify-end gap-4">
                    <Button appearance="ghost" onClick={handleClose}>Cancel</Button>
                    <Button appearance="primary" onClick={handleSubmit}>Save changes</Button>
                </div>
            </Modal.Footer>
        </Modal>

    )
}

export default KidInfo;
